import { Component } from '@theme/component';

/**
 * Drop alert SMS button with add-to-cart style feedback.
 * SMS opens via the native <a href="sms:"> navigation (same as locked JOIN LIST).
 * Do not delay or rewrite navigation: mobile browsers require the user gesture.
 *
 * @typedef {object} DropAlertSmsRefs
 * @property {HTMLAnchorElement} smsButton
 * @extends {Component<DropAlertSmsRefs>}
 */
class DropAlertSmsComponent extends Component {
  requiredRefs = ['smsButton'];

  /**
   * @param {MouseEvent & { target: HTMLElement }} event
   */
  handleClick = (_event) => {
    const { smsButton } = this.refs;
    if (!smsButton) return;

    // Visual feedback only. Keep default link behavior so sms: opens Messages
    // the same way as the locked-page JOIN LIST button.
    smsButton.classList.add('atc-added');
  };
}

if (!customElements.get('drop-alert-sms-component')) {
  customElements.define('drop-alert-sms-component', DropAlertSmsComponent);
}
